import { months } from "moment";
import React from "react";

import "./PrintTemplate.css";
import { useTranslation } from "react-i18next";

interface Props {
  toningData: any;
}

const translationPrefix = 'Printing';

const PrintTemplateA5 = (props: Props) => {
  const getFormattedDate = () => {

    var date = new Date();
    var month = date.getMonth() + 1;
    var formattedMonth = month < 10 ? `0${month}` : month;
    var year = date.getFullYear();
    var day = date.getDate();
    var formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
debugger;
  return (
    <div className="printContainer">
      <div className="row headlineRow">
        <div className="col-6">
          <h2 className="printHeadlineA5 boldedText">{t('ReceiptWithSystemInfo')}</h2>
        </div>
        <div className="col-6 rightAlignment">
          <h2 className="printHeadlineA5">{`${t('IssueDate')}: ${getFormattedDate()}`}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <span className="printLabelA5">{t('SampleBook')}</span>
        </div>
        <div className="col-9 boldedText printValueA5">
          {props.toningData.sampleCardName}
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <span className="printLabelA5"> {t('Color')}</span>
        </div>
        <div className="col-9 boldedText printValueA5">
          {props.toningData.colorName}
        </div>
      </div>
      <div className="row">
        <div className="col-3">
         <span className="printLabelA5">   {t('Product')}</span>
        </div>
        <div className="col-9 boldedText printValueA5">
          {props.toningData.productName}
        </div>
      </div>
      <div className="row">
        <div className="col-3">
           <span className="printLabelA5">  {t('Base')}</span>
        </div>
        <div className="col-9 boldedText printValueA5">
          {props.toningData.baseName}
        </div>
      </div>
      <div className="row">
        <div className="col-3">
       <span className="printLabelA5">    {t('Package')}</span>
        </div>
        <div className="col-9 boldedText printValueA5">
          {props.toningData.packageName}
        </div>
      </div>


      {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
        <div className="row receiptHeader">
          <div className="col-12">
            <table className="printPigmentsTableA5">
              <thead >
                <tr>
                  <th style={{ fontWeight: 'bold', width:'35%' , fontSize : '10px' }}>
                       {t('Pigment')}
                  </th>
                  <th style={{ fontWeight: 'bold', fontSize : '10px'  }}>
                    {t('Amount')} ({`${props.toningData.pigments[0].unitCode == 'Oz' ? 'ml' :
                      props.toningData.pigments[0].unitCode.toLowerCase()}`})
                  </th>
                  {props.toningData.pigments[0].unitCode == 'Oz' &&
                    <th style={{ fontWeight: 'bold', fontSize : '10px'  }}>
                      {t('Amount')} ({props.toningData.yFormatIsActive ? 'y+oz' : props.toningData.pigments[0].unitCode.toLowerCase()})
                    </th>
                  }
                  <th style={{ fontWeight: 'bold' , width:'30%', fontSize : '10px' }}>
                    {t('Price')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
                  props.toningData.pigments.map((pigment: any) => {
                    return <tr>
                      <td>{pigment.name}</td>
                      {pigment.unitCode == 'Oz' && <>
                        <td className="rightAlignment">{pigment.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInYFormat}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      </>}
                      {pigment.unitCode != 'Oz' && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      <td className="rightAlignment printPrice">{pigment.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>
              <tfoot>
                <tr style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                  <td className="boldedText">{t('TotalAmount')}</td>
                  {props.toningData.pigments[0].unitCode == 'Oz' &&
                    <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsVolumeMl}</td>
                  }
                  <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsVolume}</td>
                  <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsPrice}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      }

      {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
        <div className="row receiptHeaderForHardeners">
          <div className="col-12">
            <table className="printHardenersTableA5">
              <thead >
                <tr>
                  <th style={{ fontWeight: 'bold', width:'35%' }}>
                    {t('Hardener')}
                  </th>
                  <th style={{ fontWeight: 'bold' }}>
                    {t('Amount')}
                  </th>
                  <th style={{ fontWeight: 'bold', width:'30%' }}>
                    {t('Price')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
                  props.toningData.hardeners.map((hardener: any) => {

                    return <tr>
                      <td>{hardener.name}</td>
                      {hardener.unitCode == 'Oz' && <>
                        <td className="rightAlignment">{hardener.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      </>}
                      {hardener.unitCode != 'Oz' && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      <td className="rightAlignment printPrice">{hardener.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>
              <tfoot>
                <tr style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                  <td className="boldedText">{t('TotalAmount')}</td>
                  {props.toningData.hardeners[0].unitCode == 'Oz' &&
                    <td className="boldedText rightAlignment">{props.toningData.formattedHardenersVolumeMl}</td>
                  }
                  <td className="boldedText rightAlignment">{props.toningData.formattedHardenersVolume}</td>
                  <td className="boldedText rightAlignment">{props.toningData.formattedHardenersPrice}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      }

      <div className="row" style={{ marginTop: '1rem' }}>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('BasePrice')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.formattedBasePrice}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('PigmentsPrice')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.formattedPigmentsPrice}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('PackagePrice')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.formattedPackagePriceWithoutVAT}</div>
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('EnteredBy')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.currentUserName}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('Date')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{getFormattedDate()}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('Customer')}</div>
            <div className="col-6 rightAlignment"></div>
          </div>
        </div>

      </div>

      <div className="row" style={{ marginTop: '2rem' }}>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('CountOfPackages')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.numberOfPackages}</div>
          </div>
          {props.toningData.discount && props.toningData.discount.length > 0 &&
            <div className="row">
              <div className="col-6 printNormalTextA5">{t('Discount')}</div>
              <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.discount}</div>
            </div>
          }
          <div className="row">
            <div className="col-6 printNormalTextA5">{t('TotalPriceWithoutVAT')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment">{props.toningData.formattedTotalPriceWithoutVAT}</div>
          </div>
          <div className="row" style={{ fontWeight: 'bold' }}>
            <div className="col-6 printNormalTextA5">{t('TotalPriceWithVAT')}</div>
            <div className="col-6 printNormalTextA5 rightAlignment ">{props.toningData.formattedTotalPriceWithVAT}</div>
          </div>

          <div className="row" style={{ marginTop: '2rem' }}>
            <div className="col-12 printSmallTextA5">{t('Note')}<br />{props.toningData.noteExternal}</div>
          </div>
        </div>
        <div className="col-6 centered">
          <div style={{ border: '2px solid black', height: '120px', width: '100%' }}>

          </div>
          <span className="boldedText printNormalTextA5">{t('TestingDrawOfReceipt')}</span>
          <div style={{ border: '2px solid black', width: '100%', marginTop: '3rem' }}></div>
          <span className="printNormalTextA5" style={{ fontWeight: 'bold' }}>{t('MixedBy')}</span>
        </div>
      </div>
    </div>
  );
}

export default PrintTemplateA5;
